import { useLocation, useNavigate } from 'react-router-dom';

interface Props {
  buttonChildren?: JSX.Element | JSX.Element[] | null;
  pageTitle?: string;
  pageName?: string;
  navigateUrl?: string | number | any;
  isNestedBreadcrum?: boolean;
  breadcrumNested?: JSX.Element;
  breadCrumb?: boolean;
  title?: string;
  shiftNavigationUrl?: string;
  isWorksheetBreadCrumb?: boolean;
  subtitle?: string | JSX.Element;
}

export default function PageHeading(props: Props) {
  const {
    buttonChildren,
    pageTitle,
    subtitle,
    pageName,
    navigateUrl,
    isNestedBreadcrum,
    breadcrumNested,
    breadCrumb,
    title,
    shiftNavigationUrl,
    isWorksheetBreadCrumb,
  } = props;
  const navigate: any = useNavigate();
  const { state } = useLocation();
  return (
    <div className="pageHeading">
      <div className="headings">
        <div className="d-flex align-center mb-12">
          {shiftNavigationUrl && (
            <button
              className="blank-btn pl0 mr2"
              onClick={() =>
                navigate(shiftNavigationUrl, {
                  state,
                })
              }
            >
              <i className="back-icon"></i>
            </button>
          )}
          <h2 className="MuiTypography-h3 fw600">{title || pageTitle}</h2>
        </div>
        {subtitle && (
          <p className="subtitle MuiTypography-subtitle1 text-text">
            {subtitle}
          </p>
        )}
        {isNestedBreadcrum ? (
          <>{breadcrumNested}</>
        ) : (
          <>
            {pageName ? (
              <ul className="breadCrums">
                <li
                  onClick={() =>
                    typeof navigateUrl === 'function'
                      ? navigateUrl()
                      : navigateUrl
                      ? navigate(navigateUrl)
                      : undefined
                  }
                >
                  {pageTitle}
                </li>
                <li>{pageName}</li>
              </ul>
            ) : null}
          </>
        )}
      </div>
      <div className="buttons">{buttonChildren}</div>
    </div>
  );
}
